var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "animated pulse",
      class: _vm.setButtonClass,
      style: _vm.setButtonPosition,
      on: {
        click: function($event) {
          _vm.$emit("clicked")
        }
      }
    },
    [
      _vm.href != null
        ? _c("a", { class: _vm.cls, attrs: { href: _vm.href } }, [
            _vm.material_icon
              ? _c("i", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(_vm.icon))
                ])
              : _c("i", { class: _vm.icon })
          ])
        : _c(
            "div",
            {
              class: [_vm.cls, _vm.material_icon ? "material-design" : ""]
            },
            [
              _vm.material_icon
                ? _c("i", { staticClass: "material-icons" }, [
                    _vm._v(_vm._s(_vm.icon))
                  ])
                : _c("i", { class: _vm.icon })
            ]
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2108d02d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2108d02d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/buttons/FloatingButton.vue
// module id = 454
// module chunks = 0